// Auto-gegenereerd voorbeeld: Breaded Chicken Goujon.
export const GOUJON_SEED = {
 "recept": {
  "id": 1787644507924,
  "naam": "Breaded Chicken Goujon",
  "eindproduct": "Breaded Chicken Goujon Holland",
  "ingredienten": [
   {
    "id": 1787644507925,
    "categorie": "Grondstof",
    "naam": "Seperatorvlees wit 3 mm",
    "percentage": "54.74"
   },
   {
    "id": 1787644507926,
    "categorie": "Grondstof",
    "naam": "Kuiken vellen 3 mm",
    "percentage": "16.42"
   },
   {
    "id": 1787644507927,
    "categorie": "Grondstof",
    "naam": "Water",
    "percentage": "13.50"
   },
   {
    "id": 1787644507928,
    "categorie": "Hulpstof",
    "naam": "Paneermeel blank 2mm",
    "percentage": "10.95"
   },
   {
    "id": 1787644507929,
    "categorie": "Hulpstof",
    "naam": "Master Blend Chicken Schnitzel Basic",
    "percentage": "3.28"
   },
   {
    "id": 1787644507930,
    "categorie": "Grondstof",
    "naam": "Qbind Chicken FPP C Premium",
    "percentage": "1.09"
   }
  ]
 },
 "rawMaterials": [
  {
   "naam": "Seperatorvlees wit 3 mm",
   "spec": {
    "ingredientnaam": "Separatorvlees van kip",
    "allergenen": [],
    "kanBevatten": [],
    "voeding": {
     "kj": "833",
     "kcal": "199",
     "vet": "15",
     "verzadigd": "4.5",
     "koolhydraten": "0",
     "suikers": "0",
     "eiwit": "16",
     "zout": "0.2",
     "vezels": "0"
    },
    "herkomst": "Holland",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "",
    "bijgewerkt": "2026-08-25"
   }
  },
  {
   "naam": "Kuiken vellen 3 mm",
   "spec": {
    "ingredientnaam": "Kippenvel (kuikenvel)",
    "allergenen": [],
    "kanBevatten": [],
    "voeding": {
     "kj": "1811",
     "kcal": "433",
     "vet": "43",
     "verzadigd": "12",
     "koolhydraten": "0",
     "suikers": "0",
     "eiwit": "11.5",
     "zout": "0.2",
     "vezels": "0"
    },
    "herkomst": "Holland",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "",
    "bijgewerkt": "2026-08-25"
   }
  },
  {
   "naam": "Qbind Chicken FPP C Premium",
   "spec": {
    "ingredientnaam": "kippenproteïne",
    "allergenen": [],
    "kanBevatten": [],
    "voeding": {
     "kj": "1778",
     "kcal": "421",
     "vet": "10",
     "verzadigd": "3",
     "koolhydraten": "3",
     "suikers": "0.1",
     "eiwit": "82",
     "zout": "1.2",
     "vezels": "0.5"
    },
    "herkomst": "",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "",
    "bijgewerkt": "2026-08-25"
   }
  },
  {
   "naam": "Sojaolie",
   "spec": {
    "ingredientnaam": "geraffineerde sojaolie",
    "allergenen": [],
    "kanBevatten": [],
    "voeding": {
     "kj": "3700",
     "kcal": "900",
     "vet": "100",
     "verzadigd": "15.8",
     "koolhydraten": "0",
     "suikers": "0",
     "eiwit": "0",
     "zout": "0",
     "vezels": "0"
    },
    "herkomst": "",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "Volledig geraffineerd - vrijgesteld van allergenen-etikettering (EU Bijlage II)",
    "bijgewerkt": "2026-08-25"
   }
  }
 ],
 "helpers": [
  {
   "naam": "Paneermeel blank 2mm",
   "type": "Breader",
   "spec": {
    "ingredientnaam": "paneermeel (TARWEbloem, water, gist, zout)",
    "allergenen": [
     "Gluten",
     "Tarwe"
    ],
    "kanBevatten": [],
    "voeding": {
     "kj": "1500",
     "kcal": "358",
     "vet": "2",
     "verzadigd": "0.3",
     "koolhydraten": "74",
     "suikers": "1",
     "eiwit": "12",
     "zout": "1",
     "vezels": "1"
    },
    "herkomst": "",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "",
    "bijgewerkt": "2026-08-25"
   }
  },
  {
   "naam": "Battermix Clazing V4",
   "type": "Battermix",
   "spec": {
    "ingredientnaam": "batter (TARWEbloem, zetmeel, tapioca, zout, specerijen, zwarte peper, kerrie, koriander, paprikapoeder, kurkuma, groenten, uienpoeder)",
    "allergenen": [
     "Gluten",
     "Tarwe"
    ],
    "kanBevatten": [
     "Soja",
     "Mosterd",
     "Selderij",
     "Sesam",
     "Melk",
     "Eieren"
    ],
    "voeding": {
     "kj": "1351",
     "kcal": "322",
     "vet": "1.2",
     "verzadigd": "0.3",
     "koolhydraten": "68.8",
     "suikers": "0.9",
     "eiwit": "8",
     "zout": "4",
     "vezels": "1"
    },
    "herkomst": "",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "",
    "bijgewerkt": "2026-08-25"
   }
  },
  {
   "naam": "Master Blend Chicken Schnitzel Basic",
   "type": "Marinade/Kruiden",
   "spec": {
    "ingredientnaam": "kruidenmix (zout, maltodextrine, stabilisator (E451i), natuurlijk aroma, dextrose, voedingsvezel (citrus), specerijen (zwarte peper), specerij-extract (capsicum))",
    "allergenen": [],
    "kanBevatten": [
     "Sulfiet (SO2)"
    ],
    "voeding": {
     "kj": "532",
     "kcal": "127",
     "vet": "0.5",
     "verzadigd": "0",
     "koolhydraten": "29.9",
     "suikers": "7.9",
     "eiwit": "0.3",
     "zout": "46.2",
     "vezels": "5.1"
    },
    "herkomst": "",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "",
    "bijgewerkt": "2026-08-25"
   }
  },
  {
   "naam": "Paneer Goujon (Panko + FFC 1070)",
   "type": "Breader",
   "spec": {
    "ingredientnaam": "Paneer/coating (TARWEbloem, maiszetmeel, gemodificeerd zetmeel, dextrose, zout, KIPPENEI-eiwit, specerijen)",
    "allergenen": [
     "Gluten",
     "Tarwe",
     "Eieren"
    ],
    "kanBevatten": [
     "Soja",
     "Melk",
     "Mosterd",
     "Sesam"
    ],
    "voeding": {
     "kj": "1422",
     "kcal": "340",
     "vet": "1.4",
     "verzadigd": "0.4",
     "koolhydraten": "69.2",
     "suikers": "2.3",
     "eiwit": "11.2",
     "zout": "1.8",
     "vezels": "2.8"
    },
    "herkomst": "",
    "houdbaarheid": "",
    "bewaren": "",
    "opmerking": "",
    "bijgewerkt": "2026-08-25"
   }
  }
 ],
 "productSpec": {
  "id": 1787651811840.606,
  "naam": "Breaded Chicken Goujon",
  "receptNaam": "Breaded Chicken Goujon",
  "artikelnummers": [
   "13536 - Breaded Chicken Goujon Holland 10x1kg"
  ],
  "coatingType": "2",
  "componenten": {
   "predust": "",
   "battermix": "Battermix Clazing V4",
   "breader": "Paneer Goujon (Panko + FFC 1070)"
  },
  "frituurolie": "Sojaolie",
  "batterDroog": "31",
  "gewichten": {
   "kern": "34",
   "naBatter": "38",
   "naBreader": "44",
   "naFrituur": "45",
   "naOven": "42",
   "naVries": "42"
  },
  "productinfo": {
   "specNaam": "Breaded Chicken Goujon Holland",
   "ean": "",
   "tht": "",
   "bewaren": "Bewaren bij -18 C",
   "verpakking": "10 x 1 kg (doos)",
   "gewicht": "10 kg",
   "stuks": "+/- 24 stuks per kg",
   "prijs": "",
   "herkomst": "Holland (NL)",
   "landVanOorsprong": "Nederland",
   "gewichtPerStuk": "",
   "gmo": "Dit product bevat geen ingredienten of additieven die volgens EU-verordeningen 1829/2003 en 1830/2003 als GMO gedeclareerd moeten worden.",
   "omschrijving": "Krokant gepaneerde kipreepjes (goujons), voorgebakken en diepgevroren.",
   "bereiding": "Frituren: 175 C, ca. 3-4 min tot goudbruin (kerntemperatuur min. 76 C). Oven: 200 C, ca. 12-14 min. Vanuit bevroren bereiden.",
   "etikettering": "",
   "tracering": "Productnaam + houdbaarheidsdatum.",
   "houdbaarheid": "Diepvries 18 maanden na productie bij een opslagtemperatuur van minimaal -18°C.",
   "bedoeldGebruik": "Het product dient volledig te worden doorverhit voordat het wordt geconsumeerd.",
   "fysisch": "Vorm, kleur, geur en smaak: producteigen en niet afwijkend.",
   "metaaldetectie": "Dit product gaat direct na het verpakken door de metaaldetector.",
   "microAeroob": "< 1.000.000 cfu/g",
   "microListeria": "< 100 cfu/g",
   "microSalmonella": "Niet aangetoond in 25 g",
   "uitgiftedatum": "",
   "declaratieOverride": "",
   "allergenenOverride": ""
  },
  "verborgen": [],
  "vertalingen": {},
  "versie": 3,
  "bijgewerkt": "2026-08-25"
 }
};
